module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    attrs: {
      "type": "file",
      "multiple": _vm.multiple
    },
    on: {
      "change": _vm.onChange
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8cd22a78"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=jade!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-file-base64/src/js/components/vue-file-base64.vue
// module id = 1439
// module chunks = 5